export default __webpack_public_path__ + "static/media/hht2_ep15_speaking_03.3cc42454.png";